import { DepartmentControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

interface UseParams {
  departmentId: string;
  locationId: string;
  xTENANTID?: string;
}

/**
 * @author rajkumar rathod
 */
export const useLinkLocationDepartment = () =>
  useMutationWithLoading(async (params: UseParams) =>
    new DepartmentControllerApi(getConfigObject()).assignDepartmentToLocation(
      params.departmentId,
      params.locationId,
      params.xTENANTID
    )
  );
